import Reveal from "@/components/Reveal";

const PILLARS = [
  {
    num: "01",
    title: "Patient Voice Intelligence",
    desc: "Patient narratives, burden signals, lived experience, quality-of-life themes, and unmet-need detection.",
  },
  {
    num: "02",
    title: "Evidence Intelligence",
    desc: "Patient experience data, PRO / COA considerations, HRQoL relevance, and evidence planning inputs.",
  },
  {
    num: "03",
    title: "Medical Impact Intelligence",
    desc: "MSL priorities, congress narrative cues, scientific exchange themes, and medical engagement signals.",
  },
  {
    num: "04",
    title: "Access Intelligence",
    desc: "HTA, payer, AMCP, ICER, value narrative, and patient-relevant access evidence inputs.",
  },
  {
    num: "05",
    title: "Lifecycle Intelligence",
    desc: "Pre-launch readiness, launch sentiment, post-launch evolution, adherence, switching, and lifecycle evidence opportunities.",
  },
];

export default function PillarsSection() {
  return (
    <section
      id="pillars"
      className="bg-ink-0 text-parchment relative overflow-hidden"
      data-testid="pillars-section"
    >
      <div className="absolute inset-0 glow-soft opacity-70 pointer-events-none" aria-hidden="true" />
      <div className="container-edge py-24 lg:py-32 relative z-10">
        <Reveal>
          <div className="grid grid-cols-12 gap-6 items-end">
            <div className="col-span-12 lg:col-span-8">
              <div className="eyebrow mb-5">The Five Intelligence Pillars</div>
              <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-[3.75rem] tracking-tight text-parchment-bright max-w-3xl leading-[1.05]">
                Patient voice at the centre.
                <span className="block italic">Strategy across the lifecycle.</span>
              </h2>
              <p className="mt-6 text-parchment/70 text-[15.5px] leading-relaxed max-w-2xl">
                The five pillars show how Voice2Evidence translates patient voice into evidence-ready strategy across functions and lifecycle stages.
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-16 border-t border-white/[0.08]">
          {PILLARS.map((p, i) => (
            <Reveal
              key={p.num}
              delay={i * 70}
              className="group border-b border-white/[0.08] py-10 lg:py-12 hover:bg-white/[0.02] transition-colors duration-300"
              data-testid={`pillar-${p.num}`}
            >
              <div className="grid grid-cols-12 gap-6 items-start">
                <div className="col-span-12 md:col-span-2">
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-rust">Pillar {p.num}</div>
                </div>
                <div className="col-span-12 md:col-span-5">
                  <h3 className="font-serif text-3xl lg:text-4xl text-parchment-bright tracking-tight">
                    {p.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-5">
                  <p className="text-parchment/75 text-[15px] leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
